export default "__VITE_ASSET__CXQm2die__"